module.exports = __webpack_public_path__ + "img/undraw_mail_sent_re_0ofv.3ed1b4bd.svg";